import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

import '../FeaturedProducts/FeaturedProducts.css';
import shape from '../../../../assets/resources/shape.png';
import { getTitle } from '../../../../helpers/admin/productHelper';
import { formatMainImage, formatProductReviews } from '../../../../helpers/shop/shopHelper';

//MUI
import { Box, Typography, Stack, useMediaQuery, Button } from '@mui/material';
import { styled } from "@mui/material/styles";

import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

// import required modules
import { Pagination, Autoplay, Navigation } from "swiper";

const CustomButton = styled(Button)(({ theme }) => ({
    color: '#fff',
    backgroundColor: '#56C596',
    paddingLeft: '20px',
    paddingRight: '20px',
    fontWeight: '600',
    '&:hover': {
        backgroundColor: '#358f69',
        color: '#fff'
    }
}));

const PromotionProducts = () => {
    const matches = useMediaQuery('(max-width:610px)');
    // productos en tienda
    const { promotionProducts } = useSelector(state => state.shop);
    
    return (
        <>
            {
                promotionProducts.length >= 1 &&
                    <>
                        <Box mb={3} textAlign={matches ? 'center' : 'left'}>
                            <Typography
                                sx={{ fontWeight: 'bold', fontSize: '26px' }}
                                gutterBottom
                            >
                                Productos en promoción
                            </Typography>
                            <CustomButton variant='contained' sx={{ textTransform: 'none' }}
                                LinkComponent={Link} to='/promociones'>
                                Ver todo
                            </CustomButton>
                        </Box>
                        <Swiper
                            breakpoints={{
                                0: {
                                    slidesPerView: 1,
                                },
                                610: {
                                    slidesPerView: 2,
                                },
                                800: {
                                    slidesPerView: 2,
                                },
                                950: {
                                    slidesPerView: 3,
                                },
                                1100: {
                                    slidesPerView: 3,
                                },
                                1200: {
                                    slidesPerView: 5,
                                },
                            }}
                            spaceBetween={25}
                            autoHeight={true}
                            navigation={{
                                nextEl: '.promotion-swiper-button-next',
                                prevEl: '.promotion-swiper-button-prev',
                            }}
                            loop={true}
                            pagination={{
                                clickable: true,
                                dynamicBullets: true,
                            }}
                            modules={[Navigation, Pagination, Autoplay]}
                            className="promotion_swiper">
                            {
                                promotionProducts.map(({
                                    prod_var_id, title, variant_title, url, price,
                                    barcode, images, review_summary, item_promotion
                                }) => {
                                    const img = formatMainImage(images);
                                    const full_title = getTitle(title, variant_title);
                                    // reseñas de producto
                                    const { review_prom, review_count } = formatProductReviews(review_summary);
                                    const { promo, price: promo_price, text, fontSize, description: promotionDescription } = item_promotion;

                                    return (
                                        <SwiperSlide style={{ textAlign: 'center', marginTop: '5px' }} key={prod_var_id}>
                                            <Box className='box_promotion' sx={{ p: 2 }}>
                                                <Link to={`/tienda/producto/${url}/${barcode}`}>
                                                    <div className="product-in-promotion">
                                                        <img src={ img.id }
                                                            width='100%' style={{ objectFit: 'contain' }}
                                                            className="shop-product" alt={ img.alt }
                                                        />
                                                        {
                                                            promo !== '' &&
                                                                <div className="shop_top-image" title={promotionDescription}>
                                                                    <img src={shape} alt={shape} width='75'
                                                                        style={{ pointerEvents: 'none' }}
                                                                    />
                                                                    <div className="shop_centered_image">
                                                                        <Typography sx={{
                                                                            color: '#fff', fontSize, fontWeight: 'bold'
                                                                        }}>
                                                                            { text }
                                                                        </Typography>
                                                                    </div>
                                                                </div>
                                                        }
                                                    </div>
                                                </Link>

                                                <Box sx={{ textAlign: 'center', mt: 1 }}>
                                                    <Link to={`/tienda/producto/${url}/${barcode}`}
                                                        style={{ textDecoration: 'none', color: '#000' }}>
                                                        {
                                                            !matches ?
                                                                <Typography
                                                                    variant="body1"
                                                                    component="div"
                                                                    sx={{ fontWeight: '600' }}
                                                                >
                                                                    {
                                                                        full_title.length > 28 ?
                                                                            `${full_title.substring(0, 28)}...`
                                                                        :
                                                                            `${full_title}`
                                                                    }
                                                                </Typography>
                                                            :
                                                                <Typography
                                                                    variant="body1"
                                                                    component="div"
                                                                    sx={{ fontWeight: '600' }}
                                                                >
                                                                    { full_title }
                                                                </Typography>
                                                        }
                                                    </Link>
                                                </Box>

                                                <Box sx={{ display: 'flex', justifyContent: 'center', mt: .5 }}>
                                                    <div className="ratings-shop">
                                                        {
                                                            review_count > 0 ?
                                                                Array.from(Array(review_prom), (e, j) => {
                                                                    return <i className="fas fa-star"
                                                                        style={{
                                                                            color: '#FFA41C',
                                                                            stroke: "#FFA41C",
                                                                            strokeWidth: 0
                                                                        }}
                                                                        key={j}></i>
                                                                })
                                                                :
                                                                <>
                                                                    <i className="far fa-star"></i>
                                                                    <i className="far fa-star"></i>
                                                                    <i className="far fa-star"></i>
                                                                    <i className="far fa-star"></i>
                                                                    <i className="far fa-star"></i>
                                                                </>
                                                        }
                                                    </div>
                                                </Box>

                                                <Box sx={{
                                                    display: 'flex', mt: 1,
                                                    justifyContent: { xs: 'center', sm: 'center', md: 'center' },
                                                }}>
                                                    {
                                                        ['DescuentoProducto', 'DescuentoMarca'].includes(promo) ?
                                                            <Stack
                                                                direction="row"
                                                                justifyContent="flex-start"
                                                                alignItems="baseline"
                                                                spacing={1}>
                                                                <Typography variant="h6"
                                                                    sx={{ fontWeight: '600', color: '#000', textDecoration: 'line-through' }}>
                                                                    ${price}
                                                                </Typography>
                                                                <Typography variant="h6"
                                                                    sx={{ fontWeight: '600', color: '#F90606' }} align='center'>
                                                                    ${promo_price}
                                                                </Typography>
                                                            </Stack>
                                                        :
                                                            <Typography variant="h6"
                                                                sx={{ fontWeight: '600', color: '#F90606' }} align='center'>
                                                                ${price}
                                                            </Typography>
                                                    }
                                                </Box>
                                            </Box>
                                        </SwiperSlide>
                                    )
                                })
                            }
                        </Swiper>
                    </>
            }
        </>
    );
};

export default PromotionProducts;
